(function() {
  var SWIPER_SEL = '[data-el-steps-swiper]';

  function initSection(section) {
    var swiperEl = section.querySelector(SWIPER_SEL);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var nav = section.querySelector('.el-steps__nav');
    var prevEl = nav ? nav.querySelector('.swiper-button-prev') : null;
    var nextEl = nav ? nav.querySelector('.swiper-button-next') : null;
    var paginationEl = nav ? nav.querySelector('.swiper-pagination') : null;

    var stepsSwiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 16,
      breakpoints: {
        0: { slidesPerView: 1.333, spaceBetween: 12 },
        981: { slidesPerView: 3, spaceBetween: 16 }
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      }
    });
  }

  function run() {
    document.querySelectorAll('.el-steps').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector && e.target.querySelector(SWIPER_SEL)) {
      initSection(e.target);
    }
  });
})();
